import React from 'react'
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check-circle.svg'
import { AppDetailIcon } from '../../../icons/AppDetailIcon'
import ListRow from '../ListRow/ListRow'
import list from '../ListRow/ListRow.module.scss'

function LorRow({ title, dateLabel, onView = null, isLoading, hasFile = false }) {
	const showMeta = Boolean(dateLabel && dateLabel !== '—')

	return (
		<ListRow
			className={[list['row--lor'], list['row--cta'], list['row--actionable']]
				.filter(Boolean)
				.join(' ')}
			leading={
				hasFile && !isLoading ? (
					<CheckCircleIcon
						className={list.leadingIcon}
						aria-hidden
					/>
				) : null
			}
			title={title}
			subtitle={dateLabel || '—'}
			subtitleIcon={
				showMeta && !isLoading ? (
					<AppDetailIcon
						name="schedule"
						size={14}
						className={list.subtitleIcon}
					/>
				) : null
			}
			trailing={
				<span className={[list.action, list.static].join(' ')}>View</span>
			}
			onRowClick={onView || undefined}
			isLoading={isLoading}
		/>
	)
}

export default LorRow
